import { StyledImage, StyledBox } from './photo-divider.styles';
import { PhotoDividerProps } from './photo-divider.types';

export const PhotoDivider = ({ imgAlt, imgSrc }: PhotoDividerProps) => {
  return (
    <StyledBox>
      <StyledImage
        src={imgSrc}
        alt={imgAlt}
        loading="lazy"
      />
    </StyledBox>
  );
};